module.exports = __webpack_public_path__ + "static/chris-profile-64e961c60e28a2d1d689fd4b524867c9.jpg";